import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React, { useEffect } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const mock = [
  {
    image:
      'https://images.pexels.com/photos/6214480/pexels-photo-6214480.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    description: 'Drive sales to your business with well crafted designs',
    title: 'E Commerce',
    color: '#183167',
  },
  {
    image:
      'https://images.pexels.com/photos/6612990/pexels-photo-6612990.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    description: 'Get your business noticed globally with beautiful layouts',
    title: 'Business Website',
    color: '#CE371F',
  },
  {
    image:
      'https://images.pexels.com/photos/5076528/pexels-photo-5076528.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    description: 'Designed to keep readers engaged',
    title: 'Blogging',
    color: '#ECB3BE',
  },
  {
    image:
      'https://images.pexels.com/photos/4260477/pexels-photo-4260477.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    description: 'Organised learning website',
    title: 'School System',
    color: '#000000',
  },
];

const Folio = () => {
  const scrollTop = () => {
    console.log('i was clicked');
    window.scrollTo({
      top: 0 + 4171,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', () => {
      console.log(window.scrollY);
    });
  });
  const theme = useTheme();
  return (
    <Box>
      <Grid container spacing={2}>
        {mock.map((item, i) => (
          <Grid key={i} item xs={12} md={6}>
            <Box
              sx={{
                position: 'relative',
                overflow: 'hidden',
                borderRadius: 2,
                '&:hover': {
                  '& img': {
                    transform: 'scale(1.2)',
                  },
                },
                '& .lazy-load-image-loaded': {
                  display: 'flex !important',
                },
              }}
            >
              <Box
                component={LazyLoadImage}
                height={'80vh'}
                width={1}
                src={item.image}
                alt="..."
                effect="blur"
                minHeight={{ xs: 400, md: 600 }}
                sx={{
                  transition: 'transform .7s ease !important',
                  transform: 'scale(1.0)',
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                }}
              />
              <Box
                position={'absolute'}
                bottom={0}
                left={0}
                right={0}
                padding={3}
                sx={{
                  backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0) 2%, ${item.color})`,
                }}
              >
                <Typography
                  variant={'h4'}
                  fontWeight={700}
                  sx={{ color: 'common.white' }}
                >
                  {item.title}
                </Typography>
                <Typography
                  variant={'h6'}
                  fontWeight={700}
                  sx={{ color: 'common.white' }}
                  gutterBottom
                >
                  {item.description}
                </Typography>
                <Button
                  size={'large'}
                  variant={'contained'}
                  color={'secondary'}
                  onClick={scrollTop}
                  sx={{
                    display: {
                      xl: 'block',
                      lg: 'block',
                      sm: 'none',
                      xs: 'none',
                    },
                  }}
                >
                  Learn more
                </Button>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Folio;
